import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import { Base64 } from "js-base64"
import { PaginatedSearchPayload, SearchPayload } from "../../../search/SearchPayload"
import SearchService from "../../../search/SearchService"
import { PaymentItemsResult } from "../models/paymentItemsResult"

const OBJECT_TYPE = "payments"

const PREFERENCE_TYPE = "listingPayments"

type PaymentListingSearchPayload = Omit<SearchPayload, "fields" | "lightResult" | "objects">

export class Service {

    static transformIntoSearchPayload(payload: PaymentListingSearchPayload) {
        
        const { filters: availableFilters, fields } = SearchService.getTotalsFiltersAndFields({
            typeOfSearch: OBJECT_TYPE
        })

        const transformedPayload = SearchService.getSearchPostData(
            payload.filters, 
            OBJECT_TYPE, 
            availableFilters, 
            undefined, 
            [OBJECT_TYPE], 
            [], 
            fields, 
            payload.keywords
        )

        return {
            ...payload,
            ...transformedPayload,
        }
    }

    static async findPayments(payload: PaymentListingSearchPayload) : Promise<PaymentItemsResult> {
        const res = await AppContext.getApiClient().post("/listing/search", Service.transformIntoSearchPayload(payload))
        if (res.error) {
            throw new Error(res.error.message)
        } 

        return res as PaymentItemsResult
    }

    static async findPaymentsByIds(
        paymentIds: string[], 
        paginatedSearch : PaginatedSearchPayload) : Promise<PaymentItemsResult> {

        const postData = {
            keywords: "*",
            objects: [OBJECT_TYPE],
            fields: [],
            pageSize: paginatedSearch.pageSize,
            activePage: paginatedSearch.activePage,
            sortByField: "capturedAt",
            sortAsc: false,
            filters:  {
                "_id" : paymentIds
            },
            lightResult: true,
        }
   
        const res = await AppContext.getApiClient().post("/listing/search", postData)
        if (res.error) {
            throw new Error(res.error.message)
        } 

        const paymentItemResult = res as PaymentItemsResult
        const originalPaymentIds = new Set<string>()
        
        paymentItemResult.data.forEach(payment => {
            if (payment.originalPaymentId) {
                originalPaymentIds.add(payment.originalPaymentId)
            }
        })
        
        const filteredPayments = paymentItemResult.data.filter(payment => !originalPaymentIds.has(payment.id))
        paymentItemResult.data = filteredPayments
        
        return paymentItemResult
    }

    static async getListingPreferences() {
        
        const url = "/users/" + AppContext.getUserLoggedIn().id + "/preferences"
        const preferences = await AppContext.getApiClient().get(url)

        return JSON.parse(Base64.decode(preferences.attributes[PREFERENCE_TYPE]))
    }

    static saveListingPreferences(preferences: object) {
        
        const url = "/users/" + AppContext.getUserLoggedIn().id + "/preferences"
        
        return AppContext.getApiClient().patch(url, {
            [PREFERENCE_TYPE]: Base64.encode(JSON.stringify(preferences))
        })
    }
}


// WEBPACK FOOTER //
// ./src/state/listing/payment/service/service.ts